import React, { useState, useEffect, useRef } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, Tooltip, Grid,  Autocomplete, TextField, MenuItem, Toolbar, Select, InputBase, Menu } from "@mui/material";
import SettingIcon from "../../../../../../asset/image/setting2.svg";
import DeleteIcon from "../../../../../../asset/image/delete2.svg";
import RunNow from "../../../../../../asset/image/ci_play.svg";
import download_icon from "../../../../../../asset/image/download_icon.svg"
import EdgeLinkIcon from "../../../../../../asset/image/EdgeLinkIcon.svg";
import EdgeLinkIconDisabled from "../../../../../../asset/image/linkDisabled.svg";
import userEditImage from "../../../../../../asset/image/user_edit.svg";
import EditSquare from "../../../../../../asset/image/EditSquare.svg"
import RefreshIcon from "../../../../../../asset/image/refresh-cw.svg";
import InternetIcon from "../../../../../../asset/image/internet-icon.svg";
import InternetGreyIcon from "../../../../../../asset/image/internet-grey-icon.svg";
import ascSorting from "../../../../../../asset/image/AscSort.svg";
import descSorting from "../../../../../../asset/image/DescSort.svg";
import ascSortingActive from "../../../../../../asset/image/ascSortingSelected.svg";
import descSortingActive from "../../../../../../asset/image/descSortingSelected.svg";
import LanIconGreen from "../../../../../../asset/image/lan-icon.svg";
import WifiIconGreen from "../../../../../../asset/image/wifi-icon.svg";
import LanIconRed from "../../../../../../asset/image/LanIconRed.svg";
import WifiIconRed from "../../../../../../asset/image/WifiIconRed.svg";
import LanIconGrey from "../../../../../../asset/image/LanIconGrey.svg";
import WifiIconGrey from "../../../../../../asset/image/WifiIconGrey.svg";
import WanIconGreen from "../../../../../../asset/image/WanIconGreen.svg";
import WanIconRed from "../../../../../../asset/image/WanIconRed.svg";
import WanIconGrey from "../../../../../../asset/image/WanIconGrey.svg";
import canIcon from '../../../../../../asset/image/can-icon.png';
import online_status_icon from "../../../../../../asset/image/online_status_icon.svg";
import offline_status_icon from "../../../../../../asset/image/offline_status_icon.svg";
import unknown_status_icon from "../../../../../../asset/image/unknown_status_icon.svg";
import mpk_icon from "../../../../../../asset/image/mpk_icon.svg";
import Captive from "../../../../../../asset/image/Captive.svg";
import HA_icon from "../../../../../../asset/image/HA_icon.svg";
import Exclamation from "../../../../../../asset/image/Exclamation.svg";
import PAGEDOWN from "../../../../../../asset/image/pagination_down.svg";
import grey_settings from "../../../../../../asset/image/grey_settings.svg";
import order_column_enabled from "../../../../../../asset/image/order_column_enabled.svg";
import order_column_disabled from "../../../../../../asset/image/order_column_disabled.svg";
import HA_disabled from "../../../../../../asset/image/HA_disabled.svg";
import High_Availability from "../../../../../../asset/image/High_Availability.svg";
import "./NetworkTable.css";
import FilterSearchAddBar from "../../FilterSearchAddBar/FilterSearchAddBar";
import RouterIcon from '../../../../../../asset/image/routerIcon.svg';
import ap_mode_icon from '../../../../../../asset/image/ap_mode_icon.svg'
import fileBlueBg from '../../../../../../asset/image/fileBlueBg.svg';
import clockblueborder from '../../../../../../asset/image/clockblueborder.svg';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { DEFAULT_DATE_FORMAT, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../../../../../utils/constants";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { convertDateTimeIntoTimezone, netmaskToCIDR, readableBytesAsGB } from "../../../../../../utils/util";
import ImageWithFallback from "../../../../../../components/ImageWithFallback";
import TablePagination from "../../TablePagination";
import JsonTooltip, { JsonDataTooltip } from "../../../../../../components/JSONTooltip/JsonTooltip";
import { Replay } from "@mui/icons-material";
import TokenGenration from "../../../../../../asset/image/tokenGenration.svg";
import { displayToastError } from "../../../../../../server/request";
import { toast } from "react-toastify";
import InfoIcon from '@mui/icons-material/Info';

const imageMap: Record<string, string> = {
  fileBlueBg,
  clockblueborder
};

export interface NetworkTableRow {
  order?: number;
  status_history?: string;
  rate_limit?: string;
  deviceCount?: number;
  serving_device?: string;
  metadata?: string;
  show_ha_icon?: boolean;
  disabled_portal?: boolean;
  color?: string;
  isCaptive?: boolean;
  id: string;
  name?: string;
  domains?: string;
  physicalInterface?: string;
  linkState?: string;
  type?: string;
  linkType?: string;
  network?: string;
  enabled?: boolean;
  status?: string;
  iconType?: "lan" | "wan" | "wifi" | "usb";
  ssid?: string;
  primary_interface?: string;
  key?: string;
  device?: string;
  mode?: string;
  test?: string;
  vlanId?: string;
  active?: boolean;
  alias?: string;
  alias_tmp?:string;
  interface_type?: string;
  link_type?: string;
  network_alias?: string;
  vlan_id?: string;
  profile_name?: string;
  interface_ip?: string;
  dhcp?: boolean;
  dhcp_gateway?: string;
  dns_server?: string;
  is_primary?: boolean | string;
  anchor_device?: string;
  current_EOS_version?: string;
  last_seen?: string;
  editableText?: string;
  site?: string;
  connectedDevices?: string | number;
  usageTotal?: string | number;
  uploadTotal?: string | number;
  downloadTotal?: string | number;
  uploadRate?: string | number;
  downloadRate?: string | number;
  hostname?: string;
  device_id?: string;
  ip_address?: string;
  mac_address?: string;
  network_name?: string;
  usage_total?: string;
  download_total?: string;
  upload_total?: string;
  download_rate?: string;
  upload_rate?: string;
  security?: string;
  konnect_status?: string;
  services?: any;
  interface_tmp?: string;
  SSID?: string;
  site_name?: string;
  gateway_address?: string;
  band_channel?: string;
  networkCIDR?: string;
  no_of_clients?: string;
  interface_name?: string;
  network_cidr?: string;
  device_name?: string;
  radio?: string;
  channel?: string;
  channel_width?: string;
  tx_power?: string;
  SINR?: string;
  client?: string;
  DID?: string;
  userName?: string;
  time?: string;
  action?: string;
  source_address?: string;
  destination_address?: string;
  gateway?: string;
  no_nat?: string;
  interface_type_tmp?: string;
  proto?: string;
  dest_port?: string;
  dest_ip?: string;
  src_port?: string;
  src_ip?: string;
  wan_name?: string;
  mac?: string;
  ip?: string;
  desc?: string;
  vlan_name?: string;
  target?: string;
  multicast?: string;
  domain?: string;
  server?: string;
  src?: string;
  dest?: string;
  bypasscaptive?: boolean;
  hub_enabled?: boolean;
  hub_ips?: string;
  imageName?: string;
  splitImageName?: string;
}

export enum ColumnType {
  metadata = "metadata",
  text = "text",
  textWithImage = "textWithImage",
  textWithService = "textWithService",
  hyperlinkText = "hyperlinkText",
  hover = "hover",
  services = "services",
  sliderText = "sliderText",
  orderColumn = "orderColumn",
  actions = "actions",
  password = "password",
  conditional = "conditional",
  boolean = 'boolean',
  combinedColumn = 'combinedColumn',
  listWithLabel = 'listWithLabel',
  onlineOffline = 'onlineOffline',
  editableText = 'editableText',
  enableDisableIcon = 'enableDisableIcon',
  json = "json",
  timestamp = "timestamp",
  splitColumn = 'splitColumn',
  splitColumnWithImage = 'splitColumnWithImage',
  interfaceDetails = 'interfaceDetails',
  statusWithActions = 'statusWithActions',
}

type onlineOfflineItem = {
  iconId: string;
  statusText: string;
};

export type NetworkTableAction = "setting" | "refresh" | "delete" | "portal" | "edit" | "runNow" | "update_HA" | "download" | "more";

export interface ColumnConfig {
  activeBg?: any;
  splitColumnBy?: string;
  formatDateAndTime?: boolean;
  formatTopApps?: boolean;
  formatPercentage?: boolean;
  formatAsGB?: boolean;
  formatDate?: boolean;
  formatPlain?: boolean;
  label: string;
  infoIcon?: boolean;
  infoIconMessage?: string;
  key: keyof NetworkTableRow | "custom";
  type: ColumnType;
  status?: 'active' | 'inactive' | 'internal';
  order?: number;
  maxChars?:number,
  nameWithNum?:boolean,
  maxWidth?: string;
  suffixKey?: keyof NetworkTableRow;
  renderSuffix?: (value: any) => React.ReactNode;
  renderCell?: (value: any) => React.ReactNode;
  width?: string;
  minWidth?: string;
  actions?: NetworkTableAction[] | ((row: NetworkTableRow) => NetworkTableAction[]);
  booleanList?: string[];
  onlineOfflineList?: onlineOfflineItem[];
  combinedColumnList?: string[];
  columnListSeperator?: string;
  dynamicMap?: {
    [interfaceType: string]: {
      label: string;
      key: string;
      valueKey?: string;
      suffixKey?: string;
    };
  };
  sortable?: boolean;
  blue?: boolean;
  black?: boolean;
  borderR?: boolean;
  borderGradient?: string;
  moreActions?: Array<{
    key: string;
    label: string;
    icon?: string;
    disabled?: (row: NetworkTableRow) => boolean;
  }>;
}
interface Props {
  data: NetworkTableRow[];
  columns: ColumnConfig[];
  onToggle?: (headerKey: string, value: boolean, row: NetworkTableRow) => void;
  onHyperlinkClick?: (headerKey: string, value: string, row?: NetworkTableRow) => void;
  getOnhoverDetails?: (currentQuota: any) => JSX.Element[];
  handleServiceDetails?: (row: any) => void;
  onActionClick: (
    type: "setting" | "refresh" | "delete" | "portal" | "edit" | "runNow"| "retry"  | "update_HA" | "download",
    headerKey: string,
    row: NetworkTableRow,
    e?: any
  ) => void;
  showFilterBar?: boolean;
  addButtonLabel?: string;
  onAddClick?: () => void;
  enablePagination?: boolean;
  rowsPerPageOptions?: number[];
  defaultRowsPerPage?: number;
  headingHeight?: number;
  visibleColumns?: string[];
  maxHeight?: string | number;
  userTimezone?: any;
  externalSearchValue?: string;
  totalRowCount?: number;
  onPageChange?: (newPage: number, newRowsPerPage: number) => void;
  onRowsPerPageChange?: (rowsPerPage: number) => void;
  page?: number;
  rowsPerPage?: number;
  onSortChange?: (columnKey: string) => void;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  showInterfaceIcons?: boolean;
  onInterfaceTypeClick?: (value: string) => void;
  deviceInfo?: String;
  minwidth?: number;
  onDragDropRow?: (row: NetworkTableRow, index: number) => void;
}

const NetworkTable: React.FC<Props> = ({
  data,
  columns,
  onToggle,
  onHyperlinkClick,
  getOnhoverDetails,
  handleServiceDetails,
  onActionClick,
  showFilterBar,
  addButtonLabel,
  onAddClick,
  enablePagination = false,
  rowsPerPageOptions = [10, 15, 25],
  defaultRowsPerPage = 15,
  headingHeight,
  visibleColumns,
  maxHeight,
  externalSearchValue,
  totalRowCount,
  onPageChange,
  onRowsPerPageChange,
  page,
  rowsPerPage,
  onSortChange,
  sortBy,
  sortOrder,
  userTimezone,
  showInterfaceIcons,
  onInterfaceTypeClick,
  deviceInfo,
  minwidth=650,
  onDragDropRow
}) => {

  const handleCopyDID = (deviceId: string) => {
    try {
      // Validate input
      if (typeof deviceId !== "string" || deviceId.length < 6) {
        throw new Error("Invalid deviceId");
      }

      const devicePrefix = deviceId.substring(0, 2).toUpperCase();
      if (devicePrefix !== 'VX' && devicePrefix !== 'CH') {
        throw new Error('DID must start with VX or CH');
      }

      let encodedToken = '';

      // Check if this is the display format: VX1K{year}{month}AAAAA{serial} or CH1K{year}{month}AAAAA{serial}
      // Example: VX1K47AAAAA000136, VX1K5BAAAAA123456, CH1K47AAAAA000136
      const displayFormatMatch = deviceId.match(/^(VX|CH)1K([0-9A-F])([0-9A-F])AAAAA(\d{6})$/i);
      
      if (displayFormatMatch) {
        // Display format - need to ENCODE it to create the token
        const year = displayFormatMatch[2];
        const month = displayFormatMatch[3];
        const serial = displayFormatMatch[4];
        
        // Create the year/month byte: 0x{year}{month}
        const yearMonthByte = parseInt(year + month, 16);
        
        // Split serial into 3 hex bytes (each 2 digits as hex)
        // Serial 000136 → 0x00, 0x01, 0x36
        // Note: The serial digits are treated as hexadecimal pairs
        const byte1 = parseInt(serial.substring(0, 2), 16); // First 2 digits as hex
        const byte2 = parseInt(serial.substring(2, 4), 16); // Middle 2 digits as hex
        const byte3 = parseInt(serial.substring(4, 6), 16); // Last 2 digits as hex
        
        // Create byte array
        const data = new Uint8Array([yearMonthByte, byte1, byte2, byte3]);
        
        // Calculate check byte
        let check = 0;
        for (let i = 0; i < data.length; i++) {
          check += data[i];
        }
        const checkByte = check & 255;
        
        // Add check byte to data
        const finalData = new Uint8Array(5);
        finalData.set(data, 0);
        finalData[4] = checkByte;
        
        // Base64 URL-safe encode
        const base64String = btoa(String.fromCharCode.apply(null, Array.from(finalData)));
        encodedToken = base64String
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/, ''); // Remove padding
      } else {
        // Already encoded format - token should be 7 characters after VX1K/CH1K + year + month
        // Example: VX1K5BWxI0Vvc or CH1K5BWxI0Vvc
        if (deviceId.length < 13) {
          throw new Error("Encoded DID must be at least 13 characters");
        }

        encodedToken = deviceId.substring(6, 13);
      }

      // Copy encoded token to clipboard
      navigator.clipboard.writeText(encodedToken).then(() => {
        toast.success(`Token ${encodedToken} copied to clipboard!`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
        });
      }).catch((err) => {
        console.error('Failed to copy token:', err);
        toast.error('Failed to copy token', {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
    } catch (err) {
      console.error('Failed to encode/decode DID:', err);
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      toast.error(`Failed to process DID: ${errorMessage}`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  }

  const [searchValue, setSearchValue] = useState('');
  const [filters, setFilters] = useState(false);

  const getIconForType = (iconType?: string, status?: string) => {
    if (status === "offline") {
      return InternetGreyIcon;
    }
    switch (iconType) {
      case "lan":
        return LanIconGreen;
      case "wan":
        return InternetIcon;
      case "wifi":
        return WifiIconGreen;
      case "usb":
        return InternetGreyIcon;
      default:
        return undefined;
    }
  };
  const showAddButton = (deviceInfo != 'ap' && !!addButtonLabel);
  const filteredData = React.useMemo(() => {
    const search = externalSearchValue ?? searchValue;
    if (!search) return data;

    const lower = search.toLowerCase();

    const searchableKeys = columns
      .filter((col) => col.type !== ColumnType.actions && col.key !== 'custom')
      .map((col) => col.key);

    return data.filter((row) =>
      searchableKeys.some((key) => {
        const rawValue = row[key as keyof NetworkTableRow];

        if (rawValue === null || rawValue === undefined) return false;
        const stringValue =
          typeof rawValue === 'object'
            ? JSON.stringify(rawValue)
            : String(rawValue);

        return stringValue.toLowerCase().includes(lower);
      })
    );
  }, [data, externalSearchValue, searchValue, columns]);

  const knownKeys = [
    { key: "networks", label: "Networks", valueKey: "network_alias", suffixKey: "vlan_id" },
    { key: "wan_profiles", label: "Networks", valueKey: "profileName" }
  ];

  const renderAssignmentCell = (
    row: NetworkTableRow,
    col: ColumnConfig,
    onHyperlinkClick?: (key: string, value: string, row: NetworkTableRow) => void
  ) => {
    const config = knownKeys?.find(k => Array.isArray(row[k.key]));

    if (!config) return null;

    const { key, label, valueKey, suffixKey } = config;
    const value = row[key];

    if (!Array.isArray(value) || value.length === 0) {
      return (
        <Box className="assignment-wrapper">
          <span className="assignment-label">{label}:</span>
          <span className="assignment-values"></span>
        </Box>
      );
    }

    const items = value
      ?.filter((item: any) => item != null)
      ?.map((item: any) => {
        const name = valueKey ? item?.[valueKey] : item;
        const suffix = suffixKey && item?.[suffixKey] ? `(${item[suffixKey]})` : "";
        return `${name ?? ""}${suffix}`;
      });

    const interfaceType = row.interface_type;

    return (
      <Box className="assignment-wrapper">
        <span className="assignment-label">{label}:</span>

        {interfaceType === "LAN" ? (
          <Tooltip title={
            <>
              {items?.join(", ")} <br />
              {row?.['dns_server'] && <>DNS Server: {row['dns_server']} <br /></>}
              {row?.['gateway'] && <>Gateway: {row['gateway']}</>}
            </>
          }>
            <span
              className="assignment-values"
              onClick={() => onHyperlinkClick?.(col.key.toString(), JSON.stringify(items), row)}
            >
              {items.join(", ")}
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={
              <>
                {items?.join(", ")} <br />
                {row?.['dns_server'] && <>DNS Server: {row['dns_server']} <br /></>}
                {row?.['gateway'] && <>Gateway: {row['gateway']}</>}
              </>
          }>
            <Box className="assignment-values">
              {items?.map((profileName, index) => (
                <span
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    onHyperlinkClick?.("custom", JSON.stringify([profileName]), row);
                  }}
                >
                  {profileName}
                  {index < items?.length - 1 ? "," : ""}
                </span>
              ))}
            </Box>
          </Tooltip>
        )}
      </Box>
    );
  };

  const [sortConfig, setSortConfig] = useState<{ key: keyof NetworkTableRow; direction: 'asc' | 'desc' } | null>(null);

  const sortedData = React.useMemo(() => {
    if (!sortConfig) return filteredData;

    return [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (aVal === undefined || bVal === undefined) return 0;

      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
      }

      return sortConfig.direction === 'asc'
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [filteredData, sortConfig]);


  const paginatedData = React.useMemo(() => {
    return sortedData;
  }, [sortedData]);

  const getIconByTypeAndColor = (type: string, color: string) => {
    switch (type) {
      case "WAN":
        return color === "GREEN" ? WanIconGreen :
          color === "RED" ? WanIconRed : WanIconGrey;
      case "LAN":
        return color === "GREEN" ? LanIconGreen :
          color === "RED" ? LanIconRed : LanIconGrey;
      case "WIFI":
        return color === "GREEN" ? WifiIconGreen :
          color === "RED" ? WifiIconRed : WifiIconGrey;
      default:
        return InternetIcon;
    }
  };

  const GetTopAppsImage = (props) => {
    const { app } = props;
    if (app) {
      let appName = app.includes(' ') ? app.split(' ')[0] : app.includes('-') ? app.split('-')[0] : "";
      return <ImageWithFallback src={`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${app.trim()}`} fallbackSrcs={[`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${appName.trim()}`, "https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png"]} app={app} />
    } else {
      return <img className="logo-activity paddingLogo" src={`https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png`} />
    }
  }

  const totalPages = Math.ceil((totalRowCount ?? filteredData?.length ?? 0) / (rowsPerPage ?? 10));
  const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1);

   function truncateSmart(text: string | null | undefined, maxChars: number,nameWithNum:boolean|false): string {
    if (!text || text.length <= maxChars && !nameWithNum) return text ?? '';

    let back_strng = '';
    const ellipsis = '...';
    const charsToShow = maxChars - ellipsis.length;

    const front = Math.ceil(charsToShow / 2);
    if (nameWithNum) {
      const match = text.match(/^(.*)(\(\d+\))$/); // grab number (122) and name
      if (match) {
        text = match[1]?.trim() || "";
        back_strng = match[2] || "";
      } 
      else if (text.length <= maxChars) return text ?? '';
      else {
        // fallback: just truncate with ellipsis at the end
        return text.substring(0, maxChars - ellipsis.length) + ellipsis;
    }
    } else {
      const back = Math.floor(charsToShow / 2);
      back_strng = text.substring(text.length - back);
    }
    
    let final_strng = text.substring(0, front);
    if (back_strng && back_strng !== undefined && back_strng.trim() !== '')
      final_strng+= `${ellipsis}${back_strng}`;
    return final_strng;
  }

  const renderIcon = () => {
        return <img alt="dropdown" className="rowsSelectIcon" src={PAGEDOWN} />
  }
  const [pagevalue, setPagevalue] = useState(1);
  const [orderedRows, setRows] = useState<any>([]);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<NetworkTableRow | null>(null);
  const [selectedColKey, setSelectedColKey] = useState<string>("");

  const handleMoreClick = (e: React.MouseEvent<HTMLButtonElement>, row: NetworkTableRow, colKey: string) => {
    e.stopPropagation();
    setMoreAnchorEl(e.currentTarget);
    setSelectedRow(row);
    setSelectedColKey(colKey);
  };

  const handleMoreClose = () => {
    setMoreAnchorEl(null);
    setSelectedRow(null);
    setSelectedColKey("");
  };

  useEffect(() => {
    if (paginatedData?.length) {
      setRows(paginatedData);
    }
  }, [paginatedData]);

  const handleDragStart = (e: React.DragEvent, index: number) => {
    setDraggedIndex(index);
  };

  const handleDrop = (e: React.DragEvent, dropIndex: number) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    let updated = [...orderedRows];
    const [movedRow] = updated.splice(draggedIndex, 1);

    updated.splice(dropIndex, 0, movedRow);

    const reordered = updated.map((r, i) => ({
      ...r,
      order: i + 1,
    }));

    setRows(reordered);

    if (onDragDropRow) {
      const newIndex = reordered.findIndex(r => r.id === movedRow.id);
      onDragDropRow({ ...movedRow, order: newIndex + 1 }, newIndex + 1);
    }
    setDraggedIndex(null);
  };

  const getReasonTitle = (row) => {
    if (row.status) {
      if (row?.status.includes("failed") || row?.status.includes("Failed")) {
        if (row?.reason) {
          return row?.reason;
        }
      }
    }
    return ""
  }

  return (<>
    {showFilterBar && (
      <FilterSearchAddBar
        config={[
          ...(showFilterBar ? ["filterButton", "searchBar"] : []),
          ...(showAddButton ? ["addButton"] : []),
          ...(showInterfaceIcons ? ["interfaceIcons"] : []),
        ]}
        filters={filters}
        setFilters={setFilters}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        onAddClick={onAddClick}
        addLabel={addButtonLabel}
        onInterfaceTypeClick={onInterfaceTypeClick}
      />
    )}
    <div className="TableDiv">
      {enablePagination && <TablePagination rowsPerPageOptions={rowsPerPageOptions} rowsPerPage={rowsPerPage} onRowsPerPageChange={onRowsPerPageChange} page={page} totalRowCount={totalRowCount} onPageChange={onPageChange}/>}
      <TableContainer
        component={Paper}
        className="network-table-container"
        sx={{
          overflowX: "auto",
          overflowY: 'auto',
          maxHeight: maxHeight ?? '350px',
        }}
      >
        <Table sx={{ minWidth: `${minwidth}px` }} aria-label="collapsible sticky table" stickyHeader >
          <TableHead>
            <TableRow sx={{
              borderWidth: '1px 0px 1px 0px',
              borderStyle: 'solid',
              borderColor: '#EBEBEB',
            }}>
              {columns
                ?.filter((col) => !visibleColumns || visibleColumns.includes(col.key))
                ?.map((col, index) => (

                  <TableCell
                    key={index}
                    sx={{
                      padding: "3.9px",
                      height: headingHeight || 20,
                      maxWidth: col.maxWidth || "initial",
                      minWidth: col.minWidth || "initial",
                      width: col.width || 'initial',
                      fontFamily: 'Inter !important',
                      fontWeight: '600 !important',
                      fontSize: '12px !important',
                      lineHeight: '100% !important',
                      letterSpacing: '0px !important',
                      textAlign: 'center !important',
                      color: col.blue ? "white !important": col.black ? "white !important" : '#8B8D97 !important',
                      background: col.blue ? "#244c84 !important" : col.black ? "#000000 !important" : "#F5F5F5 !important",
                      borderRight: col.borderR ? "1px solid #e5e5e5" : "none",
                      ...(col.borderGradient && {
                        borderBottom: "1px solid transparent",
                        borderImageSource: col.borderGradient,
                        borderImageSlice: 1
                      })
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={0.5}
                      sx={{ cursor: col.sortable ? 'pointer' : 'default' }}
                      onClick={() => {
                        if (col.sortable && onSortChange) {
                          onSortChange(col.key.toString() === 'services' ? "criticalAlertCount" : col.key.toString());
                        }
                      }}
                    >
                      <span>{col.label}</span>
                      {
                        col?.infoIcon && 
                        <Tooltip placement="left" title={col?.infoIconMessage || ""}>
                          <InfoIcon style={{fill:"#2860b4", height:"16px"}}/>
                        </Tooltip>
                        
                      }
                      {col.sortable && (
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <img
                            src={
                              sortBy === col.key && sortOrder === 'asc'
                                ? ascSortingActive
                                : ascSorting
                            }
                            alt="asc"
                            style={{ width: '8px', height: '8px' }}
                          />
                          <img
                            src={
                              sortBy === col.key && sortOrder === 'desc'
                                ? descSortingActive
                                : descSorting
                            }
                            alt="desc"
                            style={{ width: '8px', height: '8px' }}
                          />
                        </Box>
                      )}

                    </Box>
                  </TableCell>


                ))}
            </TableRow>
          </TableHead>
          {filteredData && filteredData.length !== 0 ? (
            <TableBody>
              {orderedRows?.map((row, i) => (
                <TableRow key={`${row.id}_${i}`} sx={{ height: "36px" }} style={{background: row?.activeBg ? row?.activeBg : 'unset'}}>
                  {columns
                    .filter((col) => !visibleColumns || visibleColumns.includes(col.key))
                    .map((col, idx) => (

                      <TableCell
                        key={idx}
                        sx={{
                          maxWidth: col.maxWidth || "initial",
                          minWidth: col.minWidth || "initial",
                          wordBreak: "break-word",
                          height: "36px",
                          padding: idx === columns.length - 1 ? "4px 12px 4px 8px" : "4px 8px",
                          lineHeight: "16px",
                          verticalAlign: "middle",
                          borderRight: col.borderR ? "1px solid #e5e5e5" : "none",
                          color: row?.activeColor ? `${row.activeColor} !important` : '#45464E',
                          textTransform: row?.textTransform || "none" 
                        }}
                      >
                        {/* {col.type === ColumnType.text && (row[col.key as keyof NetworkTableRow] as any)} */}
                        {col.type === ColumnType.text && (() => {
                          const rawVal = row[col.key as keyof NetworkTableRow] ?? "-";
                          if (col.renderCell) return col.renderCell(rawVal as any);
                          
                          // Special handling for 'id' column with VX/CH devices - add token button
                          if (col.key === 'id' && typeof rawVal === 'string' && (rawVal.toUpperCase().startsWith('VX') || rawVal.toUpperCase().startsWith('CH'))) {
                            return (
                              <Box display="flex" alignItems="center" gap="8px">
                                <span
                                  style={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {rawVal}
                                </span>
                                { (
                                  <Tooltip title={<span className="font-size-12px">Generate Token</span>}>
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCopyDID(rawVal);
                                      }}
                                      style={{ padding: '4px' }}
                                    >
                                      <img src={TokenGenration} alt="Generate Token" style={{ width: '20px', height: '20px' }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Box>
                            );
                          }
                          
                          if(col.formatPlain) {
                            const maxChars = Math.floor(Number(col.maxWidth?.toString().match(/\d+/)?.[0] ?? '150') / 7); // default 150px, avg 7px/char
                            const truncated = truncateSmart(rawVal as string, maxChars, col.hasOwnProperty('nameWithNum') && col.nameWithNum == true ? true : false);

                            return (
                              <Tooltip title={row[col.key as keyof NetworkTableRow] as string}>
                              <span
                                // className="network-blue"
                                style={{ cursor: "pointer",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: '100%'
                                }}
                              >
                              {truncateSmart(
                                row[col.key as keyof NetworkTableRow] as string,
                                Math.floor(     
                                  Number(col.maxWidth?.toString().match(/\d+/)?.[0]) / 3),
                                col.hasOwnProperty('nameWithNum') && col.nameWithNum == true ? true : false
                              )}
                              </span>
                              </Tooltip>
                            )
                          }
                          if (col.formatAsGB) {
                            if(rawVal == 'null' || rawVal == null || !rawVal) { return 0}
                            return readableBytesAsGB(rawVal, false)
                          };
                          if (col.formatDate)
                            return convertDateTimeIntoTimezone(
                              rawVal,
                              userTimezone,
                              DEFAULT_DATE_FORMAT
                            );
                          if (col.formatDateAndTime)
                            return convertDateTimeIntoTimezone(
                              rawVal,
                              userTimezone,
                              MMDDYYYYHMMSS_DATE_FORMAT_24_HRS
                            );
                          if (col.formatPercentage)
                            return rawVal >= 0 ? Number(rawVal).toFixed(0) : '-';
                          if (col.formatTopApps && typeof rawVal === 'string' && rawVal != '-' ) {
                            return (
                              <Grid className="tableSites-topIcons"
                                onClick={() => onHyperlinkClick?.(
                                col.key.toString(),
                                row[col.key as keyof NetworkTableRow] as string, row
                              )}>
                                {rawVal.split(',').map((app, idx) => (
                                  <Tooltip key={idx} title={app.trim()}>
                                    <GetTopAppsImage app={app.trim()} />
                                  </Tooltip>
                                ))}
                              </Grid>
                            );
                          }
                          return rawVal ? rawVal : '-';
                        })()}

                        {col.type === ColumnType.metadata && (
                          <JsonDataTooltip data={row[col.key as keyof NetworkTableRow]} />
                        )}

                        {col.type === ColumnType.statusWithActions && (() => {
                          const status = row[col.key as keyof NetworkTableRow];
                          const reasonTitle = getReasonTitle?.(row);
                          const showRetry = row.deviceCount === 1 && status && status.toLowerCase().includes("failed") && !status.toLowerCase().includes("inprogress");

                          return (
                            <Box display="flex" alignItems="center" gap="4px">
                              {!status ? null : reasonTitle ? (
                                <Tooltip title={reasonTitle}>
                                  <span className="pointer">
                                    {status.length > 1 ? status.charAt(0).toUpperCase() + status.slice(1) : status.charAt(0)}
                                  </span>
                                </Tooltip>
                              ) : (
                                <span>
                                  {status.length > 1 ? status.charAt(0).toUpperCase() + status.slice(1) : status.charAt(0)}
                                </span>
                              )}
                              {showRetry && (
                                <Tooltip title="Retry">
                                  <IconButton
                                    onClick={() => onActionClick?.("retry", col.key.toString(), row)}
                                    size="small"
                                    sx={{ p: 0, ml: 0.5 }}
                                  >
                                    <Replay fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}

                              {row.status_history && (
                                <JsonTooltip className="prettyToolTip" json={JSON.stringify(row.status_history)} />
                              )}
                            </Box>
                          );
                        })()}

                        {col.type === ColumnType.editableText && (
                          <div className="displayFlex">
                            <span className="editableText">
                              {row[col.key as keyof NetworkTableRow]}
                            </span>
                            <IconButton
                              sx={{ p: 0 }}
                              onClick={() => onActionClick("edit", col.key.toString(), row)}
                            >
                              <img
                                src={userEditImage}
                                alt="edit"
                                style={{ display: "block" }}
                                width="18"
                                height="18"
                              />
                            </IconButton>
                            <span className="topology-service-icon">
                              {row?.show_ha_icon && (
                                <>
                                  {row?.id === row?.serving_device ? (
                                    <>
                                      <Tooltip title='Serving'>
                                        <img src={High_Availability} className="HA-icon" alt="HA Enabled" style={{ marginTop: '10px' }} onClick={() => onActionClick("update_HA", col.key.toString(), row)} />
                                      </Tooltip>
                                      <div className="dotted-line-bottom" />
                                    </>
                                  ) : (
                                    <>
                                      <div className="dotted-line-top" />
                                      <Tooltip title='Non-Serving'>
                                        <img src={HA_disabled} className="HA-icon" alt="HA Disabled" style={{ marginTop: '-3px' }} onClick={() => onActionClick("update_HA", col.key.toString(), row)} />
                                      </Tooltip>
                                    </>
                                  )}
                                </>
                              )}
                            </span>
                            <span className='topology-service-icon'>
                              {row?.mode == 'router' ? <img src={RouterIcon} /> : row?.mode == 'ap' ? <img src={ap_mode_icon} /> : null}
                            </span>
                          </div>
                        )}

                        {/* <img className="icon-cursor deviceUpdate" src={userEditImage} */}
                        {/* //                         alt="Update device name" title="Update device name" onClick={() => updateDeviceInfo(product.name, product.id, product.devices)} /> */}


                        {col.type === ColumnType.textWithImage && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px", overflow: "hidden" }}>
                            {row?.imageName && imageMap[row.imageName] ? (
                              <img
                                src={imageMap[row.imageName]}
                                alt={row.imageName}
                                width="24"
                                height="24"
                              />
                            ) : (
                              <Tooltip title={row?.color == 'GREEN' ? 'Online' : row?.color == 'RED' ? 'Offline' : 'Unknown'}>
                                <img
                                  src={getIconByTypeAndColor(row?.interface_type ?? "", row?.color ?? "GREY")}
                                  alt={row?.interface_type}
                                  width="16"
                                  height="16"
                                  className="clickable-icon"
                                />
                              </Tooltip>
                            )}
                            <Tooltip title={row[col.key as keyof NetworkTableRow] as string}>
                              <span
                                className="interface-name"
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  minWidth: 0,
                                }}
                              >
                                {row[col.key as keyof NetworkTableRow]}
                              </span>
                            </Tooltip>
                            {col.renderSuffix?.(col.suffixKey ? row[col.suffixKey] : undefined)}
                          </Box>
                        )}

                        {col.type === ColumnType.splitColumnWithImage && (() => {
                          const value = row[col.key as keyof NetworkTableRow] as string;
                          const parts = value ? value.split(col.splitColumnBy || ",") : [];
                          return (
                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", overflow: "hidden" }}>
                              {row?.splitImageName && imageMap[row.splitImageName] && (
                                <img
                                  src={imageMap[row.splitImageName]}
                                  alt={row.splitImageName}
                                  width="24"
                                  height="24"
                                  style={{ flexShrink: 0 }}
                                />
                              ) }
                              <div style={{ minWidth: 0 }}>
                                {parts.length ? parts.map((part, idx) => (
                                  <Tooltip key={idx} title={part.trim()}>
                                    <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                      {part.trim()}
                                    </div>
                                  </Tooltip>
                                )) : <span>-</span>}
                              </div>
                            </Box>
                          );
                        })()}

                        {col.type === ColumnType.textWithService && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <span className="interface-name">
                              {row[col.key as keyof NetworkTableRow]}
                            </span>
                            {row.isCaptive && (
                              <img
                                src={canIcon}
                                alt=""
                                width="16"
                                height="16"
                              />
                            )}
                          </Box>
                        )}

                        {col.type === ColumnType.hyperlinkText && (
                          <Tooltip title={row[col.key as keyof NetworkTableRow] as string}>
                          <span
                            className="network-blue"
                            style={{ cursor: "pointer",
                              display: "inline-block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: '100%'
                            }}
                            onClick={() =>
                              onHyperlinkClick?.(
                                col.key.toString(),
                                row[col.key as keyof NetworkTableRow] as string, row
                              )
                            }
                          >
                            {truncateSmart(
                              row[col.key as keyof NetworkTableRow] as string,
                              col.hasOwnProperty('maxChars') && Number(col.maxChars) > 0
                                    ? Number(col.maxChars)
                                    : Math.floor(Number(col.maxWidth?.toString().match(/\d+/)?.[0]) / 3),
                              col.hasOwnProperty('nameWithNum') && col.nameWithNum == true ? true : false
                            )}
                          </span>
                          </Tooltip>
                        )}

                        {col.type === ColumnType.hover && (
                          <span
                            className="network-blue"
                            style={{ cursor: "pointer" }}>
                            {row[col.key as keyof NetworkTableRow] && getOnhoverDetails?.(row[col.key as keyof NetworkTableRow])}
                          </span>
                        )}

                        {col.type === ColumnType.services && (
                          <div className="internetPresence">
                            <span className="services-icon-list">
                              <span onClick={() => handleServiceDetails?.(row)} className="status-icon">
                                <Tooltip title={row?.["criticalAlertCount"]}>
                                  {row?.["criticalAlertCount"] === "Online" ? (<img src={online_status_icon} alt="" />) : row?.["criticalAlertCount"] === "Offline" ? (<img src={offline_status_icon} alt="" />) : (<img src={unknown_status_icon} alt='' />)}
                                </Tooltip>
                              </span>
                              {(row?.["advanced_bonding"] == 1 || row?.["iphub_status"] == 1) ? (<Tooltip title={'MPK'}>
                                <img src={mpk_icon} alt="Online" />
                              </Tooltip>) : null}
                              {row?.["isCaptiveSites"] ? (<Tooltip title={'Captive'}>
                                <img src={Captive} alt="Online" />
                              </Tooltip>) : null}
                              {row?.["isHavingHA"] ? (<Tooltip title={'HA'}>
                                <img src={HA_icon} alt="Online" />
                              </Tooltip>) : null}
                              {row?.["link_avalibility_alerting"] ? (<Tooltip title={row?.["link_avalibility_details"]?.split('|')?.join(', ')}>
                                <img src={Exclamation} alt="Alerting" />
                              </Tooltip>) : null}
                            </span>
                          </div>
                        )}

                        {col.type === ColumnType.sliderText && (
                          <label className="if-switch-toggle">
                            <input
                              type="checkbox"
                              checked={row[col.key as keyof NetworkTableRow] as boolean}
                              onChange={(e) =>
                                onToggle?.(col.key.toString(), e.target.checked, row)
                              }
                              disabled={deviceInfo == 'ap' ? true: false}
                            />
                            <span className="if-slider-toggle" />
                          </label>
                        )}

                        {col.type === ColumnType.orderColumn && row ? (
                          <div
                            draggable
                            onDragStart={(e) => handleDragStart(e, i)}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, i)}
                            style={{ display: "flex", alignItems: "center", cursor: "grab" }}
                          >
                            <img
                              src={order_column_enabled}
                              alt="drag"
                              style={{ marginRight: 8 }}
                            />
                            <span>{row?.order ?? i + 1}</span>
                          </div>
                        ) : null}

                        {col.type === ColumnType.password && "********"}

                        {col.type === ColumnType.boolean &&
                          (row[col.key as keyof NetworkTableRow]
                            ? col.booleanList?.[0]
                            : col.booleanList?.[1])}

                        {col.type === ColumnType.splitColumn &&
                          (() => {
                            const value = row[col.key as keyof NetworkTableRow] as string;
                            if (!value) return "-";
                            const parts = value.split(col.splitColumnBy || ",");
                            return (
                              <div>
                                {parts.map((part, idx) => (
                                  <div key={idx}>{part}</div>
                                ))}
                              </div>
                            );
                          })()
                        }
                        {col.type === ColumnType.interfaceDetails && (() => {
                          const value = row[col.key as keyof NetworkTableRow] as Array<{ alias?: string; src_type?: string }>;

                          if (!value || value.length === 0) return "-";

                          const obj = value?.[0];

                          return (
                            <div>
                              <span>{`Alias: ${obj?.alias ?? "-"}`}</span><br />
                              <span>{`Type: ${obj?.src_type ?? "-"}`}</span>
                            </div>
                          );
                        })()}

                        {col.type === ColumnType.combinedColumn &&
                          col.combinedColumnList
                            ?.map(key => {
                              const value = row[key as keyof NetworkTableRow];

                              if (key === "netmask" && value) {
                                return `${netmaskToCIDR(value as string)}`;
                              }

                              if (key === "unit" && value) {
                                return value.toUpperCase();
                              }

                              return value || "-";
                            })
                            ?.join(col.columnListSeperator || " / ")
                        }

                        {col.type === ColumnType.conditional && (
                          row[col.key as keyof NetworkTableRow] || "-"
                        )}

                        {col.type === ColumnType.onlineOffline &&
                          (row[col.key as keyof NetworkTableRow] == "STATUS_CONNECTED"
                            ? <div>
                              <span id={col.onlineOfflineList?.[0].iconId}></span>
                              <span className="internetStatusTXT">{col.onlineOfflineList?.[0].statusText}</span>
                            </div>
                            : (row[col.key as keyof NetworkTableRow] == "STATUS_NOT_CONNECTED" || row[col.key as keyof NetworkTableRow] == "STATUS_NOT_FOUND") ? <div>
                              <span id={col.onlineOfflineList?.[1].iconId}></span>
                              <span className="internetStatusTXT">{col.onlineOfflineList?.[1].statusText}</span>
                            </div> : <div> <span>{"-"}</span></div>
                          )}
                        
                        {col.type === ColumnType.enableDisableIcon && (() => {
                          const actionLst = typeof col.actions === "function"
                            ? col.actions(row)
                            : col.actions;
                          return (
                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {actionLst?.map((action, aidx) => (
                                <Tooltip
                                  key={aidx}
                                  title={
                                    action === "more" ? "More" :
                                    action === "setting" ? "Settings" : ""
                                  }
                                >
                                <IconButton
                                  sx={{ p: 0 }}
                                  onClick={(e) => {
                                    if (action === "more") {
                                      handleMoreClick(e, row, col.key.toString());
                                      return;
                                    }
                                    if (row[col.key as keyof NetworkTableRow]) {
                                      onActionClick(action, col.key.toString(), row, e);
                                    }
                                  }}>
                                  {action === "setting" && (
                                    row[col.key as keyof NetworkTableRow] ?
                                    <img
                                      src={SettingIcon}
                                      alt="setting"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    /> : <img
                                      src={grey_settings}
                                      alt="setting"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  </IconButton>
                                </Tooltip>
                                ))}
                            </Box>
                          );
                        })()}

                        {col.type === ColumnType.actions && (() => {
                          const actionList = typeof col.actions === "function"
                            ? col.actions(row)
                            : col.actions;

                          return (
                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {actionList?.map((action, aidx) => (
                                <Tooltip
                                  key={aidx}
                                  title={
                                    action === "more" ? "More" :
                                    action === "setting" ? "Settings" :
                                    action === "refresh" ? "Refresh" :
                                    action === "delete" ? "Delete" :
                                    action === "runNow" ? "Run Now" :
                                    action === "download" ? "Download" :
                                    action === "edit" ? "Edit" :
                                    action === "portal" ? "Portal" : ""
                                  }
                                >
                                <IconButton
                                  sx={{ p: 0 }}
                                  onClick={(e) => {
                                    if (action === "more") {
                                      handleMoreClick(e, row, col.key.toString());
                                    } else {
                                      onActionClick(action, col.key.toString(), row, e);
                                    }
                                  }}
                                >
                                  {action === "more" && (
                                    <MoreHorizIcon style={{fill:"#244C84"}} fontSize="small" />
                                  )}
                                  {action === "setting" && (
                                    <img
                                      src={SettingIcon}
                                      alt="setting"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "refresh" && (
                                    <img
                                      src={RefreshIcon}
                                      alt="refresh"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "delete" && (
                                    <img
                                      src={DeleteIcon}
                                      alt="delete"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "runNow" && (
                                    <img
                                      src={RunNow}
                                      alt="runNow"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "download" && (
                                    <img
                                      src={download_icon}
                                      alt="download"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "edit" && (
                                    <img
                                      src={EditSquare}
                                      alt="edit"
                                      style={{ display: "block" }}
                                      width="18"
                                      height="18"
                                    />
                                  )}
                                  {action === "portal" && (
                                    row['konnect_status'] === "STATUS_CONNECTED" && (!row['disabled_portal']) && (!row["block_konnect"]) ?
                                      <img
                                        src={EdgeLinkIcon}
                                        alt="delete"
                                        style={{ display: "block" }}
                                        width="18"
                                        height="18"
                                      /> : (row['konnect_status'] === "STATUS_NOT_FOUND" || row['disabled_portal'] || row["block_konnect"]) ? <img
                                        src={EdgeLinkIconDisabled}
                                        alt="delete"
                                        style={{ display: "block", cursor: 'auto' }}
                                        width="18"
                                        height="18">
                                      </img> :
                                        <img
                                          src={EdgeLinkIconDisabled}
                                          alt="delete"
                                          style={{ display: "block" }}
                                          width="18"
                                          height="18">
                                        </img>
                                  )}
                                </IconButton>
                                </Tooltip>
                              ))}
                            </Box>
                          );
                        })()}


                        {col.type === ColumnType.listWithLabel && renderAssignmentCell(row, col, onHyperlinkClick)}

                      </TableCell>
                    ))}
                </TableRow>
              ))}
            </TableBody>) : (
            <TableBody className="no-data-tableBody">
              <TableRow>
                <TableCell colSpan={columns?.filter((col) => !visibleColumns || visibleColumns?.includes(col?.key))?.length} className="noData" align="center">No data available</TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <Menu
        anchorEl={moreAnchorEl}
        open={Boolean(moreAnchorEl)}
        onClose={handleMoreClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
            borderRadius: 8, 
          },
        }}
      >
        {columns
          .find(c => c.key === selectedColKey)
          ?.moreActions?.map((item, idx) => (
            <MenuItem
              key={idx}
              disabled={item.disabled?.(selectedRow!)}
              style={{fontSize:"12px"}}
              onClick={() => {
                onActionClick(
                  item.key as any,
                  selectedColKey,
                  selectedRow!
                );
                handleMoreClose();
              }}
            >
              {item.icon && (
                <img src={item.icon} width="16" style={{ marginRight: 8 }} />
              )}
              {item.label}
            </MenuItem>
          ))}
      </Menu>
    </div>
  </>
  );
};

const mapStateToProps = (state) => ({
  userTimezone: state.authReducer.userTimezone
});

export default withRouter(
  connect(mapStateToProps, {})(NetworkTable)
);